import { useParams } from "react-router-dom";
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function FeedbackPage() {
  const { trackingNumber } = useParams();
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

const submit = async () => {
  setLoading(true);

  try {
    await api.post("/api/public/feedback", {
      trackingNumber,
      rating,
      comment
    });

    setSubmitted(true);

  } catch (err: any) {

    const message =
      err?.response?.data?.message ||
      "تعذر إرسال التقييم";

    alert(message);

  } finally {
    setLoading(false);
  }
};

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <Card className="max-w-md w-full text-center">
          <CardHeader>
            <CardTitle>شكراً لك ❤️</CardTitle>
          </CardHeader>
          <CardContent>
            <p>تم استلام تقييمك بنجاح.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4" dir="rtl">
      <Card className="max-w-lg w-full">
        <CardHeader>
          <CardTitle>تقييم تجربة الاستلام</CardTitle>
        </CardHeader>

        <CardContent className="space-y-5">

          <p className="text-center">
            رقم الشحنة
            <br />
            <strong>{trackingNumber}</strong>
          </p>

          <div className="flex justify-center gap-2">
            {[1,2,3,4,5].map(v=>(
              <button
                key={v}
                onClick={()=>setRating(v)}
                className={`text-4xl ${v<=rating ? "text-yellow-500":"text-gray-300"}`}
              >
                ★
              </button>
            ))}
          </div>

          <textarea
            placeholder="اكتب ملاحظاتك (اختياري)"
            value={comment}
            onChange={(e)=>setComment(e.target.value)}
          />

          <Button
            className="w-full"
            onClick={submit}
            disabled={loading}
          >
            {loading ? "جارٍ الإرسال..." : "إرسال التقييم"}
          </Button>

        </CardContent>
      </Card>
    </div>
  );
}
